import { ApiErrorPageWithTrans } from '@components/Error/ApiErrorPageWithTrans';
import { NoddiLoadingScreenWithTrans } from '@components/Loading/NoddiLoadingScreenWithTrans';
import { FacilityTransferDirection } from '@navio/nsdk';
import { noddiAsync, URLKeys } from 'noddi-async';
import { customerRoutes } from 'noddi-util';
import { Navigate, useParams } from 'react-router-dom';

// Old per-order links from emails and QR codes land on the source facility's page for that day.
export const OrderLinkRedirect = () => {
  const { slug } = useParams() as { slug: string };
  const {
    data: link,
    isPending,
    error
  } = noddiAsync.useGet({
    type: URLKeys.getStorageTransferOrderFacilityLinkPublic,
    input: { slug }
  });

  if (isPending) {
    return <NoddiLoadingScreenWithTrans />;
  }
  if (error) {
    return <ApiErrorPageWithTrans error={error} />;
  }

  const path = customerRoutes.storageFacilityTransfers.getPath({ publicSlug: link.facilitySlug });
  return <Navigate replace to={`${path}?date=${link.date}&tab=${FacilityTransferDirection.OUTGOING}`} />;
};
